"use client"
import React from 'react';
import { Button, CardMedia } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Flag = () => {

    return (
        <Button
            onClick={() => { }}
            size="large"
            edge="start"
            color="inherit"
        >
            <CardMedia
                image={'/flag.png'}
                sx={{
                    width: "30px",
                    height: "20px"
                }}
                width={30}
                height={20}
                alt="flag"
            />
        </Button>
    )
}

export default Flag;